//送信エリア
import React, { useState }  from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Button } from '@material-ui/core';
import axios from 'axios';
import { withCookies } from 'react-cookie';
import Common from '../../Common';
import { useLocation } from "react-router-dom";
import moment from 'moment';

moment.locale('ja');

const styles = () => ({
    root: {
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'start',
        flexDirection: 'column',
        margin: '30px',
    },
    displayFlex: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    verticalSpaece: {
        margin: '0px 0px 20px 0px',
    }
});


const DeliveryButton = withCookies((props) => {
    const { cookies, classes, userData, message, kubunId, title, chatRequestFlg, msgMaxString } = props;
    const [update, setUpdata] = useState(false);
    const search = useLocation().search;
    const query = new URLSearchParams(search);
    //クエリストリングから取得したchatIdをサニタイジング
    let chatId = query.get('cid');
    if(chatId !== null){
        chatId = chatId
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');
    }
    const chatNameObj = cookies.get('COMMON_NAME_OBJ');
    const kubunName = chatNameObj !== undefined ? chatNameObj.KUBUN_NAME : 'チャットカテゴリ';

    //配信処理
    const sendUserId = async() => {
        //チャット中でないユーザの配列
        const selectedUserId = [];
        //チャット中のユーザの配列
        const usersInChatArray = [];
        if(userData.length !== 0){
            userData.map((d) => {
                if(d.checked) {
                    const dupData = selectedUserId.filter((id) => id === d.userId);
                    const usersInChatDupData = usersInChatArray.filter((id) => id === d.userId);
                    if(dupData.length === 0 && usersInChatDupData.length === 0){
                        //チャット中のユーザの場合
                        if(d.status) usersInChatArray.push(d.userId);
                        //チャット中でないユーザの場合
                        else selectedUserId.push(d.userId);
                    }
                }
            });
        }
        if( chatId !== null || (chatId === null && (selectedUserId.length !== 0 || usersInChatArray.length !== 0))){
            if(message.length <= msgMaxString && message.trim() !== '' && title.trim() !== ''){
                if(chatRequestFlg && kubunId === ''){
                    return window.alert(`${kubunName}を選択してください。`);
                }
                let res;
                if(chatId !== null) res = window.confirm('メッセージを送信しますか？');
                else res = window.confirm(`送信人数：${selectedUserId.length + usersInChatArray.length}人\nメッセージを送信しますか？`);
                if(res){
                    const token = cookies.get('token');
                    const jichitaiToken = cookies.get('x-jichitai-token');
                    const jichitaiId = cookies.get('x-jichitai-jichitaiid');
                    const supportedPersonId = cookies.get('supportedPersonId');
                    axios.post(
                        `${Common.apiServerUrl()}/api/delivery`,
                        {
                            message,
                            users: selectedUserId,
                            usersInChat: usersInChatArray,
                            supportedPersonId,
                            kubunId,
                            chatTitle: title,
                            chatRequestFlg,
                            chatId
                        },
                        {
                            headers: {
                                Accept: 'application/json',
                                'Content-Type': 'application/json',
                                'x-suppportcenter-token': token,
                                'x-jichitai-jichitaiid': jichitaiId,
                                'x-jichitai-token': jichitaiToken,
                            },
                        }
                    )
                    .then(Common.handleErrors)
                    .then((response) => {
                        if (response.success) {
                            window.alert('送信に成功しました。');
                            setUpdata(update ? false : true);
                        }
                        else{
                            if(response.unsender.length !== 0){
                                window.prompt(`code : [${response.title}]\nmessage : ${response.error_usermsg}`, response.unsender.join(',\n'));
                            }
                            else{
                                window.alert(`code : [${response.title}]\nmessage : ${response.error_usermsg}`);
                            }
                        }
                    })
                    .catch((err) => {
                        console.error('DeliveryButton.js postData:post err:' + err);
                    });
                }
            }
            else if(message.length > msgMaxString) window.alert('メッセージが最大文字数を超えています。');
            else if(title.trim() === '') window.alert('配信タイトルを入力してください。');
            else if(message.trim() === '') window.alert('メッセージを入力してください。');
        }
        else window.alert('ユーザーが選択されていません。');
    };

    return (
        <React.Fragment>
            <Grid container justifyContent="center" direction="column" alignItems="center">
                <div style={{ height: '100%' }}>
                    <div className={classes.root}>
                        <div className={classes.displayFlex + ' ' + classes.verticalSpaece}>
                            <Button className={classes.verticalSpaece} size="large" color="primary" variant="contained" onClick={() => sendUserId()}>配信</Button>
                        </div>
                    </div>
                </div>
            </Grid>
        </React.Fragment>
    );
});

export default withStyles(styles)(DeliveryButton);